import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var LogoutIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15c-3.314,0 -6,-2.686 -6,-6c0,-2.215 1.214,-4.128 3,-5.168l0,2.548c-0.615,0.703 -1,1.612 -1,2.62c0,2.209 1.791,4 4,4c2.209,0 4,-1.791 4,-4c0,-1.008 -0.385,-1.917 -1,-2.62l0,-2.548c1.786,1.04 3,2.953 3,5.168c0,3.314 -2.686,6 -6,6ZM9,9c-0.552,0 -1,-0.448 -1,-1l0,-5c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,5c0,0.552 -0.448,1 -1,1Z"
  }));
});
LogoutIcon.displayName = 'LogoutIcon';
export default LogoutIcon;